
import React from "react";
import Navbar from "@/components/Navbar";
import BusinessSearchBar from "@/components/businesses/BusinessSearchBar";
import FiltersSidebar from "@/components/businesses/FiltersSidebar";
import BusinessListings from "@/components/businesses/BusinessListings";
import { useBusinessFilter } from "@/hooks/useBusinessFilter";

const Businesses = () => {
  const {
    searchTerm,
    setSearchTerm,
    activeCategory,
    setActiveCategory,
    currentPage,
    setCurrentPage,
    viewMode,
    setViewMode,
    cityFilter,
    setCityFilter,
    regionFilter,
    setRegionFilter,
    isLoading,
    error,
    filteredBusinesses,
    paginatedBusinesses,
    totalPages,
    cities,
    availableRegions,
    handleSearch
  } = useBusinessFilter();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="bg-eco-50/50 py-10">
        <div className="container">
          <h1 className="text-3xl font-bold mb-2">Browse Eco-Friendly Businesses</h1>
          <p className="text-muted-foreground mb-6">
            Discover sustainable businesses and organizations making a positive impact
          </p>
          
          <BusinessSearchBar 
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            handleSearch={handleSearch}
          />
        </div>
      </div>
      
      <div className="container py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Filters sidebar */}
          <FiltersSidebar 
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            regionFilter={regionFilter}
            setRegionFilter={setRegionFilter}
            cityFilter={cityFilter}
            setCityFilter={setCityFilter}
            cities={cities}
            availableRegions={availableRegions}
          />
          
          {/* Main content */}
          <BusinessListings 
            isLoading={isLoading}
            error={error}
            viewMode={viewMode}
            setViewMode={setViewMode}
            filteredBusinesses={filteredBusinesses}
            paginatedBusinesses={paginatedBusinesses}
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            setActiveCategory={setActiveCategory}
            setCityFilter={setCityFilter}
            setRegionFilter={setRegionFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default Businesses;
